import { Injectable } from '@angular/core';
import { GlobalHelper } from '../Common/global.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { throwError, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class TicketService {

  constructor(private globalHelper: GlobalHelper, private httpclient: HttpClient) { }

   SaveCreateTicket(objModel, file, Message): Observable<any> {
    let formData = new FormData();
    formData.append("objModel", objModel);
    for (var i = 0; i < file.length; i++) {
      formData.append("Attachment" + i, file[i]);
    }
    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'Ticket/SaveCreateTicket?Message=' + Message, formData);

  }

  GetCustomerTicket(strdata): Observable<any> {
    var param = 'objModel=' + strdata;
    var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' });
    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'Ticket/GetCustomerTicket?' + encodeURI(param), { headers: reqHeader });
  }

  GetTicketDetails(strdata): Observable<any> {
    var param = 'objModel=' + strdata;
    var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' });
    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'Ticket/GetTicketDetails?' + encodeURI(param), { headers: reqHeader });
  }
  
  SendReplyTicket(objModel, file, Message): Observable<any> {
    let formData = new FormData();
    formData.append("objModel", objModel);
    for (var i = 0; i < file.length; i++) {
      formData.append("Attachment" + i, file[i]);
    }
    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'Ticket/SendReplyTicket?Message=' + Message, formData);

  }

  CloseTicket(TicketID): Observable<any> {
    var param = 'TicketID=' + TicketID;
    var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' });
    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'Ticket/CloseTicket?' + encodeURI(param), { headers: reqHeader });
  }

  


  // Group Admin Support

  SaveGroupAdminCreateTicket(objModel, file, Message): Observable<any> {
    let formData = new FormData();
    formData.append("objModel", objModel);
    for (var i = 0; i < file.length; i++) {
      formData.append("Attachment" + i, file[i]);
    }
    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'Ticket/SaveGroupAdminCreateTicket?Message=' + Message, formData);

  }

  GetGroupAdminTicket(strdata): Observable<any> {
    var param = 'objModel=' + strdata;
    var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' });
    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'Ticket/GetGroupAdminTicket?' + encodeURI(param), { headers: reqHeader });
  }

  GetGroupAdminTicketDetails(strdata): Observable<any> {
    var param = 'objModel=' + strdata;
    var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' });
    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'Ticket/GetGroupAdminTicketDetails?' + encodeURI(param), { headers: reqHeader });
  }
  
  SendGroupAdminReplyTicket(objModel, file, Message): Observable<any> {
    let formData = new FormData();
    formData.append("objModel", objModel);
    for (var i = 0; i < file.length; i++) {
      formData.append("Attachment" + i, file[i]);
    }
    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'Ticket/SendGroupAdminReplyTicket?Message=' + Message, formData);

  }

  CloseGroupAdminTicket(TicketID): Observable<any> {
    var param = 'TicketID=' + TicketID;
    var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' });
    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'Ticket/CloseGroupAdminTicket?' + encodeURI(param), { headers: reqHeader });
  }

   // Partner Support

   SavePartnerCreateTicket(objModel, file, Message): Observable<any> {
    let formData = new FormData();
    formData.append("objModel", objModel);
    for (var i = 0; i < file.length; i++) {
      formData.append("Attachment" + i, file[i]);
    }
    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'Ticket/SavePartnerCreateTicket?Message=' + Message, formData);

  }

  GetPartnerTicket(strdata): Observable<any> {
    var param = 'objModel=' + strdata;
    var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' });
    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'Ticket/GetPartnerTicket?' + encodeURI(param), { headers: reqHeader });
  }

  GetPartnerTicketDetails(strdata): Observable<any> {
    var param = 'objModel=' + strdata;
    var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' });
    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'Ticket/GetPartnerTicketDetails?' + encodeURI(param), { headers: reqHeader });
  }
  
  SendPartnerReplyTicket(objModel, file, Message): Observable<any> {
    let formData = new FormData();
    formData.append("objModel", objModel);
    for (var i = 0; i < file.length; i++) {
      formData.append("Attachment" + i, file[i]);
    }
    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'Ticket/SendPartnerReplyTicket?Message=' + Message, formData);

  }

  ClosePartnerTicket(TicketID): Observable<any> {
    var param = 'TicketID=' + TicketID;
    var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' });
    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'Ticket/ClosePartnerTicket?' + encodeURI(param), { headers: reqHeader });
  }

  // Super Admin Support

  GetALLTicket(strdata): Observable<any> {
    var param = 'objModel=' + strdata;
    var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' });
    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'Ticket/GetALLTicket?' + encodeURI(param), { headers: reqHeader });
  }

  GetSuperAdminTicketDetails(strdata): Observable<any> {
    var param = 'objModel=' + strdata;
    var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' });
    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'Ticket/GetSuperAdminTicketDetails?' + encodeURI(param), { headers: reqHeader });
  }
  
  SendSuperAdminReplyTicket(objModel, file, Message): Observable<any> {
    let formData = new FormData();
    formData.append("objModel", objModel);
    for (var i = 0; i < file.length; i++) {
      formData.append("Attachment" + i, file[i]);
    }
    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'Ticket/SendSuperAdminReplyTicket?Message=' + Message, formData);

  }

  CloseSuperAdminTicket(TicketID): Observable<any> {
    var param = 'TicketID=' + TicketID;
    var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' });
    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'Ticket/CloseSuperAdminTicket?' + encodeURI(param), { headers: reqHeader });
  }
}